module.exports = __webpack_public_path__ + "static/media/mt.e60486b4.svg";